export default __webpack_public_path__ + "static/media/sylabusWhiteIcon.12b4ce9b.svg";